import { alquilerApi } from '../../utils/api';
import {
  getObjectDataAction,
  createObjectDataPending,
  getListDataAction,
  saveObjectDataAction,
  deleteObjectDataAction,
  getListDeletedDataAction,
  createListDataDeletedPending,
  restoreObjectDataAction,
  getListByParentDataAction,
} from '../../utils/DataAction';

export const get = (id) =>
  getObjectDataAction({
    dataName: 'ALQUILER',
    api: alquilerApi,
    relUrl: id,
  });

export const getAllByParent = (id) =>
  getListByParentDataAction({
    dataName: 'ALQUILER',
    api: alquilerApi,
    relUrl: `indexByParent/${id}`,
  });

export const getAll = getListDataAction({
  dataName: 'ALQUILER',
  api: alquilerApi,
  relUrl: '',
});

export const save = (data) =>
  saveObjectDataAction({
    dataName: 'ALQUILER',
    api: alquilerApi,
    relUrl: '',
    data: data,
  });

export const deleted = (id) =>
  deleteObjectDataAction({
    dataName: 'ALQUILER',
    api: alquilerApi,
    relUrl: id,
  });

export const getAllDeleted = getListDeletedDataAction({
  dataName: 'ALQUILER',
  api: alquilerApi,
  relUrl: 'restore',
});

export const restore = (data) =>
  restoreObjectDataAction({
    dataName: 'ALQUILER',
    api: alquilerApi,
    relUrl: 'restore',
    data: data,
  });

export const setPending = createObjectDataPending('ALQUILER');
export const setDeletedPending = createListDataDeletedPending('ALQUILER');
